__turbopack_context__.v({
  "featured": "promoSection-module-scss-module__DjsRmW__featured",
  "featuredActions": "promoSection-module-scss-module__DjsRmW__featuredActions",
  "featuredBadge": "promoSection-module-scss-module__DjsRmW__featuredBadge",
  "featuredBadgeLogo": "promoSection-module-scss-module__DjsRmW__featuredBadgeLogo",
  "featuredBadgeText": "promoSection-module-scss-module__DjsRmW__featuredBadgeText",
  "featuredBody": "promoSection-module-scss-module__DjsRmW__featuredBody",
  "featuredExcerpt": "promoSection-module-scss-module__DjsRmW__featuredExcerpt",
  "featuredPreview": "promoSection-module-scss-module__DjsRmW__featuredPreview",
  "featuredPreviewImage": "promoSection-module-scss-module__DjsRmW__featuredPreviewImage",
  "featuredTitle": "promoSection-module-scss-module__DjsRmW__featuredTitle",
  "heading": "promoSection-module-scss-module__DjsRmW__heading",
  "headingIcon": "promoSection-module-scss-module__DjsRmW__headingIcon",
  "headingLineBreak": "promoSection-module-scss-module__DjsRmW__headingLineBreak",
  "mapActions": "promoSection-module-scss-module__DjsRmW__mapActions",
  "mapButton": "promoSection-module-scss-module__DjsRmW__mapButton",
  "mapCard": "promoSection-module-scss-module__DjsRmW__mapCard",
  "mapDescription": "promoSection-module-scss-module__DjsRmW__mapDescription",
  "mapImage": "promoSection-module-scss-module__DjsRmW__mapImage",
  "mapTitle": "promoSection-module-scss-module__DjsRmW__mapTitle",
  "promo": "promoSection-module-scss-module__DjsRmW__promo",
  "readButton": "promoSection-module-scss-module__DjsRmW__readButton",
  "right": "promoSection-module-scss-module__DjsRmW__right",
  "row": "promoSection-module-scss-module__DjsRmW__row",
});
